"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCancellationPolicy = getCancellationPolicy;
function getImportedCancellationPolicyDetails(cancellationPolicy) {
    if (!cancellationPolicy?.deadline) {
        return {
            line1: 'This item can not be cancelled',
            line2: null,
            canBeCancelled: false,
        };
    }
    if (cancellationPolicy.deadline.afterDeadlineType.toLowerCase() === 'not cancellable' &&
        cancellationPolicy.description) {
        return {
            line1: cancellationPolicy.description,
            line2: cancellationPolicy.description.toLocaleLowerCase().includes('no refund')
                ? ''
                : 'No refund if cancelled after deadline',
            canBeCancelled: true,
        };
    }
    if (cancellationPolicy.deadline.afterDeadlineType.toLowerCase().includes('penalty') &&
        cancellationPolicy.deadline.penaltyAfterDeadline?.type.toLowerCase() === 'nights') {
        return {
            line1: cancellationPolicy.description,
            line2: `${cancellationPolicy.deadline.penaltyAfterDeadline?.amount} nights penalty fee if cancelled after deadline`,
            canBeCancelled: true,
        };
    }
    if (cancellationPolicy.deadline.afterDeadlineType.toLowerCase().includes('penalty') &&
        cancellationPolicy.deadline.penaltyAfterDeadline?.type.toLowerCase() !== 'nights') {
        return {
            line1: cancellationPolicy.description,
            line2: `${cancellationPolicy.deadline.penaltyAfterDeadline?.amount} penalty fee if cancelled after deadline`,
            canBeCancelled: true,
        };
    }
    return {
        line1: 'No cancellation policy included',
        line2: null,
        canBeCancelled: true,
    };
}
function getCancellationPolicy(cancellationPolicy) {
    switch (cancellationPolicy?.policyType?.toLowerCase()) {
        case 'missing':
            return {
                line1: 'Cancellation policy missing at time of order',
                line2: null,
                canBeCancelled: false,
            };
        case 'not supported':
            return {
                line1: 'Cancellation not support for this item',
                line2: null,
                canBeCancelled: false,
            };
        case 'imported':
            return getImportedCancellationPolicyDetails(cancellationPolicy);
        case 'augmented':
            return getImportedCancellationPolicyDetails(cancellationPolicy);
        default:
            return {
                line1: 'No cancellation policy included',
                line2: null,
                canBeCancelled: false,
            };
    }
}
